import React from 'react';

// Actions
import { setLocaleTemporarily } from '@/redux/modules/intl';

// Hooks
import { useDispatch, useSelector } from 'react-redux';

// Types
import { ReduxState } from '@/redux/modules/types';
import { Dispatch } from '@/redux';

// Utils
import { isDevDebugMode } from '@/utils/environment';
import { formatMessage, LOCALE } from '@/utils/i18n';
import notification from '@/utils/notification';

// Components
import { Button } from '@capintel/component-lib/button';
import { Typography } from '@capintel/component-lib/typography';

const locales: LOCALE[] = [LOCALE.FR_CA, LOCALE.EN_CA, LOCALE.EN_US];

const LocaleToggler: React.FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const locale = useSelector((state: ReduxState) => state.intl.locale);

  if (!isDevDebugMode()) {
    return null;
  }

  const getNextLocale = () => {
    const currentIndex = locales.indexOf(locale as LOCALE);
    const nextIndex = (currentIndex + 1) % locales.length;
    return locales[nextIndex];
  };

  const clickHandler = () => {
    dispatch(setLocaleTemporarily(getNextLocale()));
    notification.success(formatMessage('Settings.Preferences.LanguageChanged'));
  };

  return (
    <>
      <Button onClick={clickHandler} variant="secondary" size="small">
        Switch to {getNextLocale()}
      </Button>
      <div className="dev-tool-panel__locale">
        <Typography variant="bodySmSemibold" color="tertiary">
          current :
        </Typography>
        <Typography variant="bodyMdSemibold" color="primary">
          {locale}
        </Typography>
      </div>
    </>
  );
};

export default LocaleToggler;
